import clsx from 'clsx';
import { useFormikContext } from 'formik';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import AutocompleteObjectV2 from '../../../../component/AutocompleteObjectV2';
import InputCellGroup from '../../../../component/input-cell-group';
import LabelRequired from '../../../../component/LabelRequired';
import TextField from '../../../../component/TextField';
import { ITiepDon } from '../../../models/TiepDonModel';
import InsuranceCheckButton from '../insurance-check-button';
import ScanQRCccdButton from '../ScanQRCccdButton';
import InsuranceCardsButton from './InsuranceCardsButton';
import InputGroupAutocomplete from '../../../../component/input-group-autocomplete';
import { getHealthOrg } from '../../../../utils/ServicesUtils';
import { VARIABLE_STRING } from '../../../../utils/Constant';

type Props = {
	isDisabled: boolean;
	handleChangeInsurance: any;
	onReadBHYTQRCode: any;
	searchBarcode: any;
	danhSachDanhMuc: any;
	handleChangeVisitAttribute: any;
	isBHYT: boolean;
};

const InsuranceInfo = ({
	isDisabled,
	handleChangeInsurance,
	onReadBHYTQRCode,
	searchBarcode,
	danhSachDanhMuc,
	handleChangeVisitAttribute,
	isBHYT,
}: Props) => {
	const { values, errors, touched, setFieldTouched, setFieldValue } =
		useFormikContext<ITiepDon>();
	const [disabled, setDisabled] = useState(false);
	const [isMienCungChiTra, setIsMienCungChiTra] = useState(
		Boolean(values?.insurance?.insNgaymienchitraYear)
	);

	useEffect(() => {
		setDisabled(isDisabled);
	}, [isDisabled]);

	const visitValues = values?.visit;
	const insuranceValues = values?.insurance;
	const patientValues = values?.patient;

	const onUpdateCard = () => {
		setDisabled(false);
	};

	return (
		<div>
			<div
				className={clsx(
					'd-flex justify-content-between',
					'spaces min-h-30 pb-8 mt-2 ps-2',
					'border-bottom-1'
				)}
			>
				<div className="d-flex gap-1 z-index-1">
					{visitValues?.id && (
						<Button className="btn-fill" onClick={onUpdateCard}>
							<i className="bi bi-credit-card-2-front-fill pe-0"></i>
							Cập nhật thẻ BHYT
						</Button>
					)}
					<InsuranceCheckButton
						patientInfo={values}
						onUpdatePatientInfoFromInsurance={onReadBHYTQRCode}
					/>
				</div>

				<div className="d-flex">
					<InsuranceCardsButton patientId={patientValues?.id ?? ''} />
					<ScanQRCccdButton
						onReadData={searchBarcode}
						label="Thông tin trên mã QR thẻ BHYT:"
						tooltip="Quét QR thẻ BHYT"
					/>
				</div>
			</div>

			<div className="d-flex mb-2 mt-1">
				<div className="spaces width-100 d-flex">
					<LabelRequired label="Số BHYT" className="ps-2 min-w-80px" />
					<InputCellGroup
						cells={[
							{
								name: 'insCodeDoiTuong',
								length: 2,
							},
							{
								name: 'insCodeMucHuong',
								length: 1,
							},
							{
								name: 'insCodeNoiPhatHanh',
								length: 2,
							},
							{
								name: 'insCodeMaBhxh',
								length: 10,
							},
						]}
						value={insuranceValues}
						onChange={(e) => {
							handleChangeInsurance(e.target.name, e.target.value);
						}}
						disabled={disabled}
						errors={errors?.insurance}
						touched={touched?.insurance}
						setFieldTouched={setFieldTouched}
						inputClassName="customs-input"
					/>
				</div>
			</div>

			<div className="d-flex mb-2">
				<LabelRequired label="KCB BĐ" className="ps-2 min-w-80px" />
				<InputGroupAutocomplete
					tableColumns={[
						{
							Header: 'Code',
							accessor: 'code',
						},
						{
							Header: 'Name',
							accessor: 'name',
						},
					]}
					inputConfig={[
						{
							label: 'Mã KCBBD',
							name: 'insKcbbdCode',
							config: {
								style: {
									flex: '0 1 80px',
								},
							},
							className: 'text-center',
						},
						{
							label: 'Tên KCBBD',
							name: 'insKcbbdName',
						},
					]}
					mode="remote"
					initialOptions={[
						{
							code: '001',
							name: 'Benh vien A'
						},
						 {
							code: '002',
							name: 'Benh vien B'
						 },
						 {
							code: '003',
							name: 'Benh vien C'
						 }
					]}
					fetchApi={getHealthOrg}
					urlData="data.content"
					getParams={(values) => ({
						pageSize: 20,
						keyword: values?.insKcbbdCode || values?.insKcbbdName,
					})}
					getTableData={(data) => {
						return data?.map((row: any) => ({
							...row,
							insKcbbdCode: row.code,
							insKcbbdName: row.name,
						}));
					}}
					value={insuranceValues}
					onChange={(values: any) => {
						setFieldValue(VARIABLE_STRING.INSURANCE, {
							...insuranceValues,
							...values,
						});
					}}
					disabled={disabled}
				/>
			</div>

			<div className="d-flex mb-2">
				<div className="spaces width-100 d-flex align-items-center">
					<LabelRequired label="Hạn thẻ" className="ps-2 min-w-80px" />
					<InputCellGroup
						cells={[
							{
								name: 'insFromDay',
								length: 2,
							},
							{
								name: 'insFromMonth',
								length: 2,
							},
							{
								name: 'insFromYear',
								length: 4,
							},
						]}
						value={insuranceValues}
						onChange={(e) => {
							handleChangeInsurance(e.target.name, e.target.value);
						}}
						disabled={disabled}
						errors={errors?.insurance}
						touched={touched?.insurance}
						setFieldTouched={setFieldTouched}
						inputClassName="customs-input"
						className="me-4"
					/>

					<InputCellGroup
						cells={[
							{
								name: 'insToDay',
								length: 2,
							},
							{
								name: 'insToMonth',
								length: 2,
							},
							{
								name: 'insToYear',
								length: 4,
							},
						]}
						value={insuranceValues}
						onChange={(e) => {
							handleChangeInsurance(e.target.name, e.target.value);
						}}
						disabled={disabled}
						errors={errors?.insurance}
						touched={touched?.insurance}
						setFieldTouched={setFieldTouched}
						inputClassName="customs-input"
					/>
				</div>
			</div>

			<div className="d-flex mb-2">
				<div className="spaces d-flex w-80">
					<LabelRequired label="Tuyến KCB" className="ps-2 min-w-80px" />
					<AutocompleteObjectV2
						options={danhSachDanhMuc?.listTuyenKCB || []}
						name="examLevel"
						value={visitValues?.attributes?.examLevel}
						onChange={(selectedOption) => {
							handleChangeVisitAttribute('examLevel', selectedOption);
						}}
						className="autocomplete-custom-tiep-nhan radius spaces h-29"
						isDisabled={!isBHYT}
					/>
				</div>
				<div className="spaces d-flex position-relative">
					<TextField
						className="ps-29px no-spinners"
						label="Mức hưởng"
						name="insCoveragePercentage"
						value={insuranceValues?.insCoveragePercentage}
						onChange={(e: any) => handleChangeInsurance(e.target.name, e.target.value)}
						type="number"
						labelClassName="spaces ps-4 min-w-90"
						disabled={true}
						inputClassName="max-w-100"
					/>
					<h6 className="position-absolute spaces top-5 right-5">%</h6>
				</div>
			</div>

			<div className="spaces d-flex ps-2 mt-10 mb-4">
				<Form.Check
					type="checkbox"
					id="insMienCungChiTra"
					className="min-w-150px d-flex align-items-center gap-2"
					disabled={disabled}
				>
					<Form.Check.Input
						type="checkbox"
						disabled={disabled}
						checked={isMienCungChiTra}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							const checked = e.target.checked;
							setIsMienCungChiTra(checked);
							if (!checked) {
								setFieldValue("insNgaymienchitraDay", "");
								setFieldValue("insNgaymienchitraMonth", "");
								setFieldValue("insNgaymienchitraYear", "");
							}
						}}
					/>
					<Form.Check.Label>Chứng nhận không cùng chi trả trong năm</Form.Check.Label>
				</Form.Check>
			</div>

			<div className="d-flex mb-2">
				<div className="spaces d-flex ms-2 flex-grow-1">
					<LabelRequired label="Ngày miễn cùng chi trả" className=" min-w-200px" />
					<InputCellGroup
						cells={[
							{
								name: 'insNgaymienchitraDay',
								length: 2,
							},
							{
								name: 'insNgaymienchitraMonth',
								length: 2,
							},
							{
								name: 'insNgaymienchitraYear',
								length: 4,
							},
						]}
						value={insuranceValues}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
							handleChangeInsurance(e.target.name, e.target.value);
						}}
						disabled={disabled || !isMienCungChiTra}
						inputClassName="customs-input"
						errors={errors?.insurance}
						touched={touched?.insurance}
						setFieldTouched={setFieldTouched}
					/>
				</div>
			</div>

			<div className="d-flex mb-2">
				<div className="spaces d-flex ms-2 flex-grow-1">
					<LabelRequired label="Ngày đóng đủ 5 năm liên tục" className=" min-w-200px" />
					<InputCellGroup
						cells={[
							{
								name: 'insNgaydu5namDay',
								length: 2,
							},
							{
								name: 'insNgaydu5namMonth',
								length: 2,
							},
							{
								name: 'insNgaydu5namYear',
								length: 4,
							},
						]}
						value={insuranceValues}
						onChange={(e) => {
							handleChangeInsurance(e.target.name, e.target.value);
						}}
						disabled={disabled}
						errors={errors?.insurance}
						touched={touched?.insurance}
						setFieldTouched={setFieldTouched}
						inputClassName="customs-input"
					/>
				</div>
			</div>
		</div>
	);
};

export default InsuranceInfo;
